import { pathToZdogPath } from "./zdogHelpers";
import * as Zdog from "zdog";
import * as Snap from "snapsvg-cjs";

let r = 22.5;

export const path =
  "m 177.60125,80.45712 c 0,-15.87 -12.2575,-27.98125 -27.30125,-27.98125 -6.90875,0 -13.0375,2.61 -17.495,6.89 l 0,-5.48 -14.15375,9.07 0,12.13875 14.97125,-0.0512 c 2.2925,-5.9 8.0225,-9.92625 14.5225,-9.92625 8.6,0 15.5775,6.9775 15.5775,15.5775 0,8.60125 -6.9775,15.57875 -15.5775,15.57875 -6.80625,0 -12.725,-4.4075 -14.79625,-10.6875 l -14.6975,0.05 0,45.78875 14.82125,0 0,-29.14625 c 4.34625,3.96625 10.2525,6.385 16.8275,6.385 15.04375,0 27.30125,-12.2325 27.30125,-28.20625 m 29.9625,-28.08625 0,12.63375 c -7.80125,0 -14.1525,6.4725 -14.1525,15.765 0,9.08375 6.35125,15.3475 14.1525,15.3475 l 0,12.65125 c -15.935,0 -28.8625,-12.025 -28.8625,-28.1025 0,-16.07875 12.9275,-28.295 28.8625,-28.295 m -149.505,6.05625 C 58.05875,44.22842 48.6975,35.04092 32.54,35.04092 l -32.54,0 0,72.47375 14.71,0 0,-25.91 18.16375,0 c 8.91375,0 16.0025,-3.31125 20.36,-8.74625 L 41.495,67.85462 c -2.3375,2.18125 -5.43,3.425 -8.695,3.425 -7.03875,0 -12.75125,-5.71125 -12.75125,-12.75125 0,-7.03875 5.7125,-12.75125 12.75125,-12.75125 6.90375,0 12.53,5.49375 12.745,12.345 l 12.0625,5.1425 c 0.29875,-1.5475 0.45125,-3.16375 0.45125,-4.8375 m 232.6225,22.23875 -14.71,0 0,5.11625 c 0,4.9075 -3.23125,9.9175 -10.475,9.9175 -7.355,0 -10.58625,-5.01 -10.58625,-9.9175 l 0,-19.1075 35.21375,0 0,-12.94625 -35.21375,0 0,-13.6775 -14.71,0 0,45 c 0,13.5725 9.91875,23.7175 25.29625,23.7175 15.37875,0 25.185,-10.145 25.185,-23.7175 l 0,-4.385 z m -83.1175,28.1025 0,-12.65125 c 7.8,0 14.1525,-6.26375 14.1525,-15.3475 0,-9.2925 -6.3525,-15.765 -14.1525,-15.765 l 0,-12.63375 c 15.935,0 28.9725,12.21625 28.9725,28.295 0,16.0775 -13.0375,28.1025 -28.9725,28.1025 m 113.97,-56.3975 0,12.63375 c -7.8,0 -14.15125,6.4725 -14.15125,15.765 0,9.08375 6.35125,15.3475 14.15125,15.3475 l 0,12.65125 c -15.935,0 -28.86125,-12.025 -28.86125,-28.1025 0,-16.07875 12.92625,-28.295 28.86125,-28.295 m 0,56.3975 0,-12.65125 c 7.80125,0 14.1525,-6.26375 14.1525,-15.3475 0,-9.2925 -6.35125,-15.765 -14.1525,-15.765 l 0,-12.63375 c 15.93625,0 28.975,12.21625 28.975,28.295 0,16.0775 -13.03875,28.1025 -28.975,28.1025";

export function getLogo(canvas, isRotateAxis = false) {
  const logo = new Zdog.Illustration({
    element: canvas,
    rotate: {},
    zoom: 1,
  });

  new Zdog.Shape({
    addTo: logo,
    path: pathToZdogPath(Snap.path.toAbsolute(path).toString(), 0),
    rotate: {},
    translate: { x: -180, y: -81 },
    closed: true,
    stroke: 1,
    fill: true,
    color: "#f2541b",
  });

  new Zdog.Shape({
    addTo: logo,
    path: pathToZdogPath(Snap.path.toAbsolute(path).toString(), 0),
    rotate: {},
    translate: { x: -180, y: -81, z: 5 },
    closed: true,
    stroke: 1,
    fill: true,
    color: "#f2541b",
  });

  let zAnchor = new Zdog.Anchor({
    addTo: logo,
    scale: 1,
    translate: { x: -95, y: 0, z: 0 },
    rotate: isRotateAxis ? { z: Math.PI * 0.13 } : {},
  });

  let main = new Zdog.Ellipse({
    addTo: zAnchor,
    diameter: r * 2,
    stroke: 15,
    color: "black",
    rotate: isRotateAxis ? { z: -Math.PI * 0.13 } : {},
  });

  function addBranch(root, x, y, sr, z) {
    let b = new Zdog.Shape({
      addTo: root,
      path: [
        {
          x: r * (x / Math.sqrt(x * x + y * y)),
          y: r * (y / Math.sqrt(x * x + y * y)),
        },
        { x: x, y: y }, //, z:z}
      ],
      stroke: 6,
      color: "black",
    });

    new Zdog.Shape({
      addTo: b,
      stroke: sr,
      translate: { x: x, y: y }, //, z: z},
      color: "black",
    });

    return b;
  }

  let branches = [
    addBranch(main, 0, -67.5, 25),
    addBranch(main, 23, -43, 19),
    addBranch(main, 53, -37, 17),
    addBranch(main, 63, 0, 25),
    addBranch(main, 23, 34.5, 17),
    addBranch(main, 0, 63, 25),
    addBranch(main, -31.5, 36, 19),
    addBranch(main, -52.5, 22, 19.5),
    addBranch(main, -52.5, -22, 19.5),
    addBranch(main, -34.5, -53.5, 17),
  ];

  return { main: logo, zAnchor, ring: main, branches };
}
